// Complete sample data for Docmize Listing Platform

export const doctors = [
  {
    id: 1,
    name: 'Dr. Rajesh Kumar',
    specialty: 'Dentist',
    experience: 15,
    education: 'BDS, MDS - Oral Surgery',
    location: 'Delhi',
    clinics: [
      {
        name: 'SmileCare Dental Clinic',
        address: 'A-123, Connaught Place, New Delhi - 110001',
        timings: 'Mon-Sat: 10:00 AM - 8:00 PM'
      }
    ],
    rating: 4.8,
    reviews: 245,
    consultationFee: 500,
    image: 'https://ui-avatars.com/api/?name=Rajesh+Kumar&background=19354a&color=fff&size=200',
    verified: true,
    availability: ['Today', 'Tomorrow'],
    languages: ['English', 'Hindi'],
    slots: {
      morning: ['09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM'],
      afternoon: ['02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM', '04:00 PM', '04:30 PM'],
      evening: ['05:00 PM', '05:30 PM', '06:00 PM', '06:30 PM', '07:00 PM', '07:30 PM']
    },
    about: 'Dr. Rajesh Kumar is a highly experienced dentist with over 15 years of practice. Specializes in cosmetic dentistry, root canal treatment, and dental implants.',
    services: ['Teeth Whitening', 'Root Canal', 'Dental Implants', 'Braces', 'Teeth Cleaning'],
    gender: 'Male'
  },
  {
    id: 2,
    name: 'Dr. Priya Sharma',
    specialty: 'Gynecologist',
    experience: 12,
    education: 'MBBS, MD - Obstetrics & Gynecology',
    location: 'Mumbai',
    clinics: [
      {
        name: 'Women\'s Health Center',
        address: 'B-456, Andheri West, Mumbai - 400053',
        timings: 'Mon-Sat: 11:00 AM - 7:00 PM'
      }
    ],
    rating: 4.9,
    reviews: 189,
    consultationFee: 800,
    image: 'https://ui-avatars.com/api/?name=Priya+Sharma&background=39a5d3&color=fff&size=200',
    verified: true,
    availability: ['Today', 'Tomorrow'],
    languages: ['English', 'Hindi', 'Marathi'],
    slots: {
      morning: ['11:00 AM', '11:30 AM'],
      afternoon: ['02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM', '04:00 PM'],
      evening: ['05:00 PM', '05:30 PM', '06:00 PM', '06:30 PM']
    },
    about: 'Dr. Priya Sharma is a compassionate gynecologist dedicated to women\'s health. Expertise in high-risk pregnancies and minimally invasive surgeries.',
    services: ['Prenatal Care', 'Gynecological Surgery', 'Family Planning', 'Menopause Management'],
    gender: 'Female'
  },
  {
    id: 3,
    name: 'Dr. Amit Patel',
    specialty: 'Cardiologist',
    experience: 20,
    education: 'MBBS, MD, DM - Cardiology',
    location: 'Bangalore',
    clinics: [
      {
        name: 'Heart Care Hospital',
        address: 'C-789, Koramangala, Bangalore - 560034',
        timings: 'Mon-Fri: 9:00 AM - 6:00 PM'
      }
    ],
    rating: 4.7,
    reviews: 312,
    consultationFee: 1200,
    image: 'https://ui-avatars.com/api/?name=Amit+Patel&background=E85A2C&color=fff&size=200',
    verified: true,
    availability: ['Tomorrow'],
    languages: ['English', 'Hindi', 'Gujarati'],
    slots: {
      morning: ['09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM'],
      afternoon: ['01:00 PM', '01:30 PM', '02:00 PM', '02:30 PM'],
      evening: ['04:00 PM', '04:30 PM', '05:00 PM', '05:30 PM']
    },
    about: 'Dr. Amit Patel is a renowned cardiologist with expertise in interventional cardiology and heart failure management.',
    services: ['ECG', 'Echocardiography', 'Angioplasty', 'Cardiac Rehabilitation'],
    gender: 'Male'
  },
  // Add 17 more doctors for complete listing
];

export const healthArticles = [
  {
    id: 1,
    title: '10 Tips for Maintaining Heart Health',
    category: 'Cardiology',
    author: 'Dr. Amit Patel',
    date: 'Jan 25, 2026',
    readTime: '5 min read',
    image: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=800&h=600&fit=crop',
    excerpt: 'Learn essential tips to keep your heart healthy and prevent cardiovascular diseases.',
    content: 'Full article content here...',
    tags: ['Heart Health', 'Prevention', 'Lifestyle']
  },
  {
    id: 2,
    title: 'Understanding Diabetes: Prevention and Care',
    category: 'Wellness',
    author: 'Dr. Sarah Johnson',
    date: 'Jan 22, 2026',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop',
    excerpt: 'Comprehensive guide to understanding, preventing, and managing diabetes.',
    content: 'Full article content here...',
    tags: ['Diabetes', 'Prevention', 'Diet']
  },
  {
    id: 3,
    title: 'Mental Health: Breaking the Stigma',
    category: 'Psychology',
    author: 'Dr. Priya Sharma',
    date: 'Jan 20, 2026',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&h=600&fit=crop',
    excerpt: 'Understanding mental health and why it\'s important to seek help.',
    content: 'Full article content here...',
    tags: ['Mental Health', 'Awareness', 'Support']
  }
];

export const healthPackages = [
  {
    id: 1,
    name: 'Full Body Checkup',
    tests: 98,
    price: 1499,
    originalPrice: 2999,
    popular: true,
    includes: [
      'Complete Blood Count',
      'Lipid Profile',
      'Kidney Function Test',
      'Liver Function Test',
      'Thyroid Profile',
      'Blood Sugar',
      'Urine Analysis',
      'ECG',
      'Chest X-Ray'
    ],
    description: 'Comprehensive health screening package covering all vital parameters.',
    sampleCollection: 'Home',
    reportDelivery: '24 hours'
  },
  {
    id: 2,
    name: 'Diabetes Screening',
    tests: 45,
    price: 799,
    originalPrice: 1599,
    popular: false,
    includes: [
      'Fasting Blood Sugar',
      'HbA1c',
      'Insulin Level',
      'Kidney Function',
      'Lipid Profile'
    ],
    description: 'Essential tests for diabetes screening and monitoring.',
    sampleCollection: 'Home',
    reportDelivery: '12 hours'
  }
];

export const labTests = [
  {
    id: 1,
    name: 'Complete Blood Count (CBC)',
    price: 299,
    originalPrice: 599,
    description: 'Comprehensive blood test to check overall health',
    sampleType: 'Blood',
    reportTime: '6 hours',
    homeCollection: true
  },
  {
    id: 2,
    name: 'Lipid Profile',
    price: 499,
    originalPrice: 899,
    description: 'Cholesterol and triglyceride levels test',
    sampleType: 'Blood',
    reportTime: '12 hours',
    homeCollection: true
  }
];

export const specialties = [
  { name: 'Dentist', icon: '🦷', count: '2,150+' },
  { name: 'Gynecologist', icon: '👶', count: '1,840+' },
  { name: 'Dermatologist', icon: '✨', count: '1,620+' },
  { name: 'Cardiologist', icon: '❤️', count: '980+' },
  { name: 'Pediatrician', icon: '👼', count: '1,450+' },
  { name: 'Orthopedic', icon: '🦴', count: '1,120+' },
  { name: 'Neurologist', icon: '🧠', count: '780+' },
  { name: 'Psychologist', icon: '🧘', count: '920+' },
  { name: 'Diabetologist', icon: '💉', count: '650+' },
  { name: 'Gastroenterologist', icon: '🫀', count: '540+' },
  { name: 'ENT Specialist', icon: '👂', count: '890+' },
  { name: 'Urologist', icon: '🩺', count: '470+' }
];

export const reviews = [
  {
    id: 1,
    doctorId: 1,
    patientName: 'Rahul Verma',
    rating: 5,
    comment: 'Excellent doctor! Very professional and caring. Highly recommended.',
    date: 'Jan 15, 2026',
    verified: true
  },
  {
    id: 2,
    doctorId: 1,
    patientName: 'Sneha Gupta',
    rating: 5,
    comment: 'Best dentist in Delhi. Painless treatment and great service.',
    date: 'Jan 10, 2026',
    verified: true
  }
];
